import z from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { Home } from '@/features/home'

const tabParamSchema = z.enum([
  'imported-leads',
  'lead-transfer',
  'auto-exclusions',
  'branch',
  'models',
  'substitutes',
  'price-lists',
  'users',
  'bookings',
  'retails',
  'offers',
  'inventory',
  'business-agents',
  'integrations',
  'configuration',
  'funnel-setup',
  'customers',
])

const homeSearchSchema = z
  .object({
    language: z.string().optional(),
  })
  .catch({})

export const Route = createFileRoute('/_authenticated/$tab')({
  params: {
    parse: (params) => ({
      tab: tabParamSchema.parse(params.tab),
    }),
    stringify: (params) => ({
      tab: params.tab,
    }),
  },
  validateSearch: homeSearchSchema,
  beforeLoad: ({ search, params }) => {
    if (!search?.language) {
      throw redirect({
        to: '/$tab',
        params: { tab: params.tab },
        search: { language: 'en' },
      })
    }
  },
  component: Home,
})
